<template>
    <div class="matchModel" :class="{'matchModelDark': isDark}">
        <div class="ph" :style="{'height': parseFloat(h) / 2 + 'px'}"></div>
        <div class="container">
            <div v-for="(item, index) in list" :key="'model'+index" class="channel">
                <big-item v-if="item.info.data_type == 15" :data="item" @goModel="goModel" @gobuy="goModel" :isDark="isDark"></big-item>
                <dimension-item v-if="item.info.data_type == 16" :data="item" @goModel="goModel" @gobuy="goModel" :isDark="isDark"></dimension-item>
                <odds-item v-if="item.info.data_type == 17" :data="item" @goModel="goModel" @gobuy="goModel" :isDark="isDark"></odds-item>
                <cool-item v-if="item.info.data_type == 18" :data="item" @goModel="goModel" @gobuy="goModel" :isDark="isDark"></cool-item>
                <possion-item v-if="item.info.data_type == 21" :data="item" @goModel="goModel" @gobuy="goModel" :isDark="isDark"></possion-item>
                <marginItem v-if="item.info.data_type == 23" :data="item" @goModel="goModel" @gobuy="goModel" :isDark="isDark"></marginItem>
                <diff-item v-if="item.info.data_type == 25" :data="item" @goModel="goModel" @gobuy="goModel" :isDark="isDark"></diff-item>
                <plan-item v-if="item.info.data_type == 26" :data="item" @goModel="goModel" @gobuy="goModel" :isDark="isDark"></plan-item>
                <super-item v-if="item.info.data_type == 28" :data="item" @goModel="goModel" @gobuy="goModel" :isDark="isDark"></super-item>
            </div>
        </div>
        <Loading v-if="isAndroid && isLoading"></Loading>
    </div>
</template>

<script>
import Loading from "../../components/common/Loading.vue";
import { getQueryVariable, isAndroid } from "../../utils/base";
import jsbridg from '../../utils/jsbridg'
import { getModelListForMatch } from '../../api/model';
import DiffItem from '../../components/datamodel/match/diffItem.vue';
import marginItem from "../../components/datamodel/match/marginItem.vue";
import possionItem from "../../components/datamodel/match/possionItem.vue";
import superItem from "../../components/datamodel/match/superItem.vue";
import coolItem from "../../components/datamodel/match/coolItem.vue";
import bigItem from "../../components/datamodel/match/bigItem.vue";
import dimensionItem from "../../components/datamodel/match/dimensionItem.vue";
import oddsItem from "../../components/datamodel/match/oddsItem.vue";
import planItem from "../../components/datamodel/match/planItem.vue";
export default {
    name: 'matchModel',
    components: {
        Loading,
        marginItem,
        DiffItem,
        possionItem,
        superItem,
        coolItem,
        bigItem,
        dimensionItem,
        oddsItem,
        planItem
    },
    data () {
        return {
            isLoading: true,
            h: getQueryVariable('h') || 0,
            list: [],
            isAndroid: isAndroid()
        }
    },
    computed: {
        isDark () {
            return this.$store.state.common.isDark
        }
    },
    created () {
        this.initData()
    },
    methods: {
        goModel (url) {
            jsbridg.goWebview({
                url: url,
                jumptype: 2
            });
        },
        async initData () {
            const res = await getModelListForMatch({
                schedule_id: getQueryVariable('schedule_id')
            });
            if (res.errno === 0) {
                this.list = res.data;
                this.isLoading = false;
            }
        }
    }
}
</script>

<style lang="less">
.matchModel{
    min-height: 100vh;
    background-color: #F5F5F5;
    .ph{
        width: 100%;
    }
    .container{
        padding: 15px;
        .channel{
            margin-top: 12px;
            &:first-child{
                margin-top: 0;
            }
            .title{
                display: flex;
                justify-content: space-between;
                width: 100%;
                height: 30px;
                align-items: center;
                .left{
                    background-color: #ffffff;
                    border-top-left-radius: 5px;
                    display: flex;
                    justify-content: flex-start;
                    height: 100%;
                    align-items: center;
                    position: relative;
                    padding: 0 20px 0 10px;
                    p{
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        img{
                            width: 15px;
                            margin-right: 6px;
                        }
                        font-size: 13px;
                        color: #333;
                        font-weight: bold;
                    }
                    span{
                        display: block;
                        height: 18px;
                        line-height: 18px;
                        border-radius: 2px;
                        background-color: #FF5048;
                        font-size: 13px;
                        color: #ffffff;
                        font-weight: bold;
                        padding: 0 5px;
                        margin-left: 10px;
                    }
                    em{
                        font-size: 10px;
                        color: #169AFF;
                        line-height: 14px;
                        margin-left: 10px;
                    }
                    &:after{
                        display: block;
                        content: "";
                        width: 0;
                        height: 0;
                        border-left: 0 solid transparent;
                        border-right: 15px solid transparent;
                        border-bottom: 30px solid #ffffff;
                        position: absolute;
                        right: -14px;
                        top: 0;
                    }
                }
                .right{
                    font-size: 10px;
                    color: #169AFF;
                    line-height: 14px;
                }
            }
            .con{
                box-shadow: 0 5px 10px rgba(0,0,0,.1);
                border-radius: 5px;
                border-top-left-radius: 0;
                overflow: hidden;
                .noVipHaveData{
                    width: 100%;
                    img{
                        display: block;
                    }
                }
                .noData{
                    background-color: #ffffff;
                    padding: 10px;
                    border-radius: 5px;
                    border-top-left-radius: 0;
                    .txt{
                        font-size: 12px;
                        color: #333;
                        line-height: 17px;
                        text-align: left;
                    }
                    .btm{
                        margin-top: 8px;
                        border-top: 1px solid #f5f5f5;
                        .top{
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            font-size: 10px;
                            height: 28px;
                            .res{
                                color: #666666;
                                span{
                                    color: #FF5048;
                                }
                            }
                            .btn{
                                width: 104px;
                                height: 20px;
                                line-height: 20px;
                                border-radius: 13px;
                                border: 1px solid #169AFF;
                                color: #169AFF;
                                text-align: center;
                            }
                        }
                        .info{
                            margin-top: 4px;
                            display: flex;
                            justify-content: space-between;
                            .bettel{
                                .team{
                                    margin-top: 6px;
                                    display: flex;
                                    align-items: center;
                                    p{
                                        font-size: 12px;
                                        color: #333;
                                        width: 82px;
                                        overflow: hidden;
                                        text-overflow: ellipsis;
                                        white-space: nowrap;
                                    }
                                    span{
                                        margin-left: 34px;
                                        font-size: 13px;
                                        color: #FF5048;
                                        font-weight: bold;
                                        line-height: 19px;
                                    }
                                }
                            }
                        }
                    }
                }
                .haveData{
                    padding: 10px;
                    background-color: #ffffff;
                }
            }
        }
    }
}
.matchModelDark{
    background-color: #191919;
    .container{
        .channel{
            .title{
                .left{
                    background-color: #232323;
                    p{
                        color: #d3d3d3;
                    }
                    span{
                        color: #d3d3d3;
                    }
                    &:after{
                        display: block;
                        content: "";
                        width: 0;
                        height: 0;
                        border-left: 0 solid transparent;
                        border-right: 15px solid transparent;
                        border-bottom: 30px solid #232323;
                        position: absolute;
                        right: -14px;
                        top: 0;
                    }
                }
            }
            .con{
                box-shadow: 0;
                .noData{
                    background-color: #232323;
                    .txt{
                        color: #d3d3d3;
                    }
                    .btm{
                        border-color: #232323;
                        .top{
                            .res{
                                color: #a6a6a6;
                            }
                        }
                        .info{
                            .bettel .team p{
                                color: #d3d3d3;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>
